function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M2 4A1.5 1.5 0 00.5 5.5v5A1.5 1.5 0 002 12h11a1.5 1.5 0 001.5-1.5v-1a1 1 0 001-1v-1a1 1 0 00-1-1v-1A1.5 1.5 0 0013 4H2z",
  fill: "currentColor"
})));